import React from "react";
import styled from "styled-components";
import { CopyToClipboard } from "../../../../../components/CopyToClipboard";
import { mixinSkins } from "../../../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { lionSkin } from "../skins/project-l";
import { ConsoleButtons } from "../../ConsoleButtons/components/ConsoleButtons";
export var BetaKeyModulePlatform;
(function (BetaKeyModulePlatform) {
    BetaKeyModulePlatform["PLAYSTATION"] = "PLAYSTATION";
    BetaKeyModulePlatform["XBOX"] = "XBOX";
})(BetaKeyModulePlatform || (BetaKeyModulePlatform = {}));
const _BetaKeyModule = ({ description, betaKey, copySuccessText, button, className, ...otherProps }) => (React.createElement("div", { className: `${className} beta-key-module`, ...otherProps },
    React.createElement(CopyToClipboard, { className: "beta-key-module_copy", description: description, item: betaKey, successText: copySuccessText }),
    button.style == BetaKeyModulePlatform.XBOX && (React.createElement(ConsoleButtons, { className: "beta-key-module_button", buttons: [
            {
                title: button.title,
                action: { type: "weblink", payload: { url: button.redirectUrl } },
            },
            { title: "", action: { type: "weblink", payload: { url: button.redirectUrl } } },
        ] })),
    button.style == BetaKeyModulePlatform.PLAYSTATION && (React.createElement(ConsoleButtons, { className: "beta-key-module_button", buttons: [
            { title: "", action: { type: "weblink", payload: { url: button.redirectUrl } } },
            {
                title: button.title,
                action: { type: "weblink", payload: { url: button.redirectUrl } },
            },
        ] }))));
export const BetaKeyModule = styled(_BetaKeyModule) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.RiotProductLion]: lionSkin,
})}
`;
//# sourceMappingURL=BetaKeyModule.js.map